// Utils
import isMatchFilter from '../../../utils/isMatchFilter';
import isActiveAndAvailable from './filtersAvailability';

// Constants
import {
  DEPENDENT_FILTER_IDS,
  OTHER_FILTER_TYPE,
} from '../../../constants/products';

const getUniqueFilterValues = (
  currentFilterId,
  otherFilterIds,
  { productIds, productsObj, filters, currentFilters },
) => {
  const filteredProductIds = productIds.filter((productId) => {
    const product = (productsObj || {})[productId];

    if (!isActiveAndAvailable(product, filters)) {
      return false;
    }

    return otherFilterIds.every((filterId) =>
      isMatchFilter(product, currentFilters, filterId),
    );
  });

  const filterValues = filteredProductIds.map(
    (productId) => productsObj[productId][currentFilterId],
  );

  return filterValues.filter(
    (value, index, arr) => arr.indexOf(value) === index,
  );
};

const isFilterOptionAvailable = (filterValue, uniqueFilterValues) => {
  if (
    filterValue.title === OTHER_FILTER_TYPE &&
    (uniqueFilterValues.includes('') || uniqueFilterValues.includes(null))
  ) {
    return true;
  }

  if (filterValue.checked) {
    return true;
  }

  return uniqueFilterValues.includes(filterValue.title);
};

const sortDependentFilterOptions = (options) =>
  [...options].sort((a, b) => {
    if (a.title === OTHER_FILTER_TYPE) return 1;
    if (b.title === OTHER_FILTER_TYPE) return -1;
    return a.title.localeCompare(b.title, undefined, { numeric: true });
  });

export const getDependentFilterOptions = (
  currentFilterId,
  currentFilters,
  context,
) => {
  const otherFilterIds = DEPENDENT_FILTER_IDS.filter(
    (id) => id !== currentFilterId,
  );

  const uniqueFilterValues = getUniqueFilterValues(
    currentFilterId,
    otherFilterIds,
    {
      ...context,
      currentFilters,
    },
  );

  const dependentFilterOptions = currentFilters[currentFilterId].filter(
    (filterValue) => isFilterOptionAvailable(filterValue, uniqueFilterValues),
  );

  return sortDependentFilterOptions(dependentFilterOptions);
};

export const getDependentFilters = (filters, getDependentFilterOptionsFn) => {
  const dependentFilters = { ...filters };
  DEPENDENT_FILTER_IDS.forEach((filterId) => {
    dependentFilters[filterId] = getDependentFilterOptionsFn(filterId, filters);
  });
  return dependentFilters;
};
